<template>
  <table class="table table-borderless table-align table-h51">
    <thead>
    <tr>
      <th>ID</th>
      <th>Conta</th>
      <th>Status</th>
      <th>Scrape ID</th>
      <th>Serviço</th>
      <th>Executor</th>
      <th>Sequência</th>
      <th>Criado em</th>
      <th>Atualizado em</th>
      <th v-if="linkConsult"></th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="request in requests" :key="request.id">
      <td>{{ request.id }}</td>
      <td>{{ getAccountName(request) }}</td>
      <td>{{ request.status | t }}</td>
      <td>{{ request.scrapeId }}</td>
      <td>{{ request.scrapingServiceName }}</td>
      <td>{{ request.executor }}</td>
      <td>{{ request.sequence }}</td>
      <td>{{ request.createdAt | datetime }}</td>
      <td>{{ request.updatedAt | datetime }}</td>
      <td v-if="linkConsult">
        <router-link :to="`/admin/maestro/consults/${request.consultId}`">
          <button class="btn btn-outline">
            Consulta
          </button>
        </router-link>
      </td>
      <td>
        <router-link :to="`/admin/maestro/requests/${request.id}`">
          <button class="btn btn-outline">
            Ver
          </button>
        </router-link>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  inject: ['getAccountName'],
  name: 'Table',
  props: {
    requests: { required: true, type: Array },
    linkConsult: { type: Boolean, default: false }
  }
}

</script>

<style scoped>

</style>